export enum Features {
  Compensation = 'compensation',
  Flag = 'flags',
}
